export const VerticalSeparator = () => {
  return <div className="before:h-full before:border-l before:border-neutral-90" />;
};
